// Принятые палитра и шрифты интерфейса.
export const UITheme = {
  background: 0x101f1c,
  panel: 0x213932,
  hover: 0x345347,
  accent: 0xb9e77a,
  warning: 0xecc778,
  text: '#f3efdb',
  muted: '#bcc9b8',
  heading: '"Rubik Mono One", Arial, sans-serif',
  body: '"Golos Text", Arial, sans-serif'
} as const;
